import { BOT_WAIT_LOADER, BUTTON_LOADER, BOT_WAIT_LOADER_WITH_SHIMMER, SEARCH_LOADER, SET_LOADER, UPLOAD_FILE_LOADER } from "../constants";

const initialState = {
	botWaitLoader: false,
	botWaitLoaderWithShimmerOnly: false,
	searchLoader: false,
	buttonLoader: false,
	uploadFileLoader: false,
	loading: false
};

const loaderReducer = (state = initialState, action) => {
	switch (action.type) {
		case BOT_WAIT_LOADER:
			return {
				...state,
				botWaitLoader: action.data,
			};

		case BOT_WAIT_LOADER_WITH_SHIMMER:
			return {
				...state,
				botWaitLoaderWithShimmerOnly: action.data,
			};

		case UPLOAD_FILE_LOADER:
			return {
				...state,
				uploadFileLoader: action.data,
			};

		case SEARCH_LOADER:
			return {
				...state,
				searchLoader: action.payload,
			};

		case BUTTON_LOADER:
			return {
				...state,
				buttonLoader: action.payload,
			};

		case SET_LOADER:
			return {
				...state,
				loading: action.payload,
			};

		default:
			return state;
	}
};

export default loaderReducer;
